import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'white',
  boxShadow: 24,
  borderRadius: '16px',
  p: 4,
  maxWidth: '95%',
  outline: 'none'
};

function FailedModal({ open, handleClose, handleTryAgain }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <div className="flex flex-col items-center pt-2 pb-2">
            {/* Alert Icon */}
            <div className="w-[100px] h-[100px] mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 90, 95, 0.15)' }}>
                <div className="w-[72px] h-[72px] rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 90, 95, 0.4)' }}>
                    <div className="w-[48px] h-[48px] rounded-full flex items-center justify-center bg-[#FF5A5F]">
                        <span className="text-white font-[700] text-[28px] mt-1">!</span>
                    </div>
                </div>
            </div>
            
            <h2 className="mt-2 text-[22px] font-[700] text-[#1E222B]">Payment failed</h2>
            <p className="mt-3 text-center text-[14px] text-[#1E222B] leading-relaxed max-w-[90%]">
              We could not process your payment. Please check your wallet balance or try a different payment method
            </p>
            
            <div className="mt-6 w-full bg-[#F0FDF4] p-3 rounded-xl flex items-start gap-3">
              <div className="w-5 h-5 rounded-full border-2 border-[#FF5A5F] flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-[#FF5A5F] text-[12px] font-bold">!</span>
              </div>
              <p className="text-[#FF5A5F] text-[13px] leading-relaxed">
                No amount has been deducted from your wallet, Your transaction was not completed
              </p>
            </div>

            <div className="mt-8 w-full flex flex-col gap-3">
              <button
                onClick={handleTryAgain}
                className="w-full py-3.5 rounded-xl bg-[#FF5A5F] text-white font-[700] text-[16px] transition-colors hover:bg-red-500"
              >
                Try again
              </button>
              <button
                onClick={handleClose}
                className="w-full py-3.5 rounded-xl bg-[#F9FAFB] text-[#FF5A5F] font-[700] text-[16px] transition-colors hover:bg-gray-100"
              >
                Cancel
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default FailedModal;
